import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DynamicFormService {

  private formGroup: FormGroup;
  setFormGroup(formGroup: FormGroup) {
    this.formGroup = formGroup;
  }
  getFormGroup(): FormGroup {
    return this.formGroup;
  }

  private formSubmitSubject = new Subject<void>();
  submitForm() {
    this.formSubmitSubject.next();
  }
  getFormSubmitObservable() {
    return this.formSubmitSubject.asObservable();
  }

  private formSuccessSubject = new Subject<any>();
  submitSuccess(data: any) {
    this.formSuccessSubject.next(data);
  }
  getFormSuccessObservable() {
    return this.formSuccessSubject.asObservable();
  }

  private formErrorSubject = new Subject<any>();
  submitError(errors: any) {
    this.formErrorSubject.next(errors);
  }
  getFormErrorObservable() {
    return this.formErrorSubject.asObservable();
  }

}
